import type { WorkflowAiLifecycleState } from '@aline/common';

export function getWorkflowAiBuildStatusLabel(
  state: WorkflowAiLifecycleState
): 'Building' | 'Cancelled' | 'Needs attention' | 'Ready' {
  switch (state) {
    case 'building':
      return 'Building';
    case 'cancelled':
      return 'Cancelled';
    case 'failed':
      return 'Needs attention';
    case 'finished':
    case 'idle':
      return 'Ready';
  }
}
